import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import { Svg } from "@natera/material/lib/svg";
import MaintenanceSvg from "@assets/svg/maintenance.svg";
import "./patientEducation.scss";

const messages = defineMessages({
  errorTitle: {
    id: "patientEducation.error.title",
    defaultMessage: "We're unable to find this link.",
  },
  errorMessage: {
    id: "patientEducation.error.message",
    defaultMessage:
      "Please check the link you received or contact your healthcare provider for assistance.",
  },
});

const ErrorPage: FC = () => {
  const intl = useIntl();

  return (
    <div className="patient-education-error">
      <div className="patient-education-error__container">
        <div className="patient-education-error__icon">
          <Svg content={MaintenanceSvg} />
        </div>

        <div className="patient-education-error__content">
          <h1 className="patient-education-error__title">
            {intl.formatMessage(messages.errorTitle)}
          </h1>
          <p className="patient-education-error__message">
            {intl.formatMessage(messages.errorMessage)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
